import { Divider, Heading, VStack } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { TextBlock } from '../../common/components/TextBlock';
import { UI } from '../../common/shells/UI';
import { Featurebase } from './components/Featurebase';
import { Section } from './components/Section';

export const RoadMapView: React.FC = () => {
  return (
    <UI>
      <VStack alignItems={'flex-start'} w="full" margin="0 auto" gap={['20px', '20px', '40px']}>
        <VStack alignItems={'flex-start'} w="full">
          <Heading
            fontSize={['32px', '32px', '48px']}
            lineHeight={'48px'}
            fontWeight={'normal'}
            fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
            Ideas
          </Heading>
          <Featurebase />
        </VStack>
        <Divider w="full" />
        <VStack alignItems={'flex-start'}>
          <Heading
            fontSize={['32px', '32px', '48px']}
            lineHeight={'48px'}
            fontWeight={'normal'}
            fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
            What's next?
          </Heading>
          <TextBlock color="gray.400" fontSize="20px">
            Upcoming improvements for Concreit Web
          </TextBlock>
        </VStack>
        <VStack gap={['20px', '20px', '40px']} w="full">
          <Section
            title="Learning Center"
            subtitle="Whether you're a rookie getting into real estate or an investing veteran , we've got you covered. Our learning center will help you grow your money."
            image="/assets/gfx/roadmap-learning-center.png"
            imageWidth={506}
            link="https://concreit.featurebase.app/submissions/645bbf28d2a544168d444cf4"></Section>
          <Section
            title="Portfolio View"
            subtitle="Portfolio provides a comprehensive overview of all of your investments to keep you updated and informed."
            image="/assets/gfx/roadmap-portfolio-view.png"
            imageWidth={584}
            link="https://concreit.featurebase.app/submissions/645bbf36d2a544168d445b78"></Section>
          <Section
            title="Financial Goals"
            subtitle="Need help with retirement or other large financial goals? Our Goals feature will give you a better shot at achieving your goals with customized plans."
            image="/assets/gfx/roadmap-financial-goals.png"
            imageWidth={548}
            link="https://concreit.featurebase.app/submissions/645bbf40d2a544168d446f59"></Section>
        </VStack>
      </VStack>
    </UI>
  );
};
